﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';

const a1 = 'a1';
const a2 = 'a2';

const aValg: RadioButtonValgModel<VeilederUtstyrsstipendDto>[] = [
    {
        id: 'a1',
        value: a1,
        tekst: 'ledetekstStudspesA1',
    },
    {
        id: 'a2',
        value: a2,
        tekst: 'ledetekstYrkesfagA2',
    },
];

export default {
    a1: a1,
    a2: a2,

    aValg,
};
